// src/App.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";

import NavBar from "./components/NavBar";
import ChatToggle from "./components/ChatToggle";
import Home from "./pages/Home";
import ServicesPage from "./pages/ServicesPage";
import About from "./pages/About";
import ContactPage from "./pages/ContactPage";
import QuoteWizard from "./pages/QuoteWizard";
import PdfPreview from "./pages/PdfPreview"; // ← NUEVO
import NotFound from "./pages/NotFound";
import Footer from "./components/Footer";
import PaymentPlans from "./pages/PaymentPlans";

export default function App() {
  return (
    <Box sx={{ fontFamily: "Roboto, sans-serif" }}>
      <NavBar />

      <Box component="main">
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<Home />} />
          <Route path="/servicios" element={<ServicesPage />} />
          <Route path="/nosotros" element={<About />} />
          <Route path="/contacto" element={<ContactPage />} />
          <Route path="/planes-pago" element={<PaymentPlans />} />
          <Route path="/cotizar" element={<QuoteWizard />} />
          <Route path="/cotizar/preview" element={<PdfPreview />} /> {/* ← */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>

      <Footer />
      <ChatToggle />
    </Box>
  );
}
